import { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import { useWaitlist } from "@/context/waitlist";

export default function EntryPage() {
  const [entered, setEntered] = useState(
    () => sessionStorage.getItem("w8ed-entered") === "1"
  );
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const openWaitlist = useWaitlist();

  const enter = () => {
    sessionStorage.setItem("w8ed-entered", "1");
    setEntered(true);
  };

  if (entered) {
    return (
      <Layout>
        <HomePage />
      </Layout>
    );
  }

  const toggleSound = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      audio.volume = 0.45;
      audio.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  };

  return (
    <main
      data-testid="entry-screen"
      className="min-h-screen bg-[#0a0a09] flex flex-col items-center justify-center px-6 text-center relative"
    >
      <div className="fade-up">
        <button
          type="button"
          aria-label="Enter W8ED"
          data-testid="entry-emblem"
          onClick={enter}
          className="group cursor-pointer"
        >
          <img
            src="/w8ed-emblem.png"
            alt="W8ED — golden eight over the mountain"
            className="w-64 sm:w-96 lg:w-[28rem] transition-[filter] duration-500 group-hover:drop-shadow-[0_0_45px_rgba(201,162,39,0.35)]"
          />
        </button>

        <p
          data-testid="entry-tagline"
          className="mt-10 font-mono text-[11px] sm:text-xs tracking-[0.35em] uppercase text-[#C9A227]"
        >
          Discipline &gt; Dopamine
        </p>

        <button
          type="button"
          data-testid="join-waitlist-button"
          onClick={openWaitlist}
          className="mt-8 border border-[#26241d] px-6 py-3 font-mono text-[11px] tracking-[0.3em] uppercase text-[#b8b3a6] hover:border-[#C9A227] hover:text-[#C9A227] transition-colors duration-300"
        >
          Join the W8LIST
        </button>
      </div>

      <audio ref={audioRef} src="/ambient.wav" loop preload="none" data-testid="ambient-audio" />
      <button
        type="button"
        aria-label="Toggle ambient sound"
        aria-pressed={playing}
        data-testid="entry-sound-toggle"
        onClick={toggleSound}
        className="absolute bottom-6 right-6 p-2 text-[#57534a] hover:text-[#C9A227] transition-colors"
      >
        {playing ? <Volume2 size={16} /> : <VolumeX size={16} />}
      </button>
    </main>
  );
}
